import React from "react";
import "../Page.css";
import "./style.css";
import google_search_logo from "../../Assets/integration/google_search_console.svg"
import google from "../../Assets/integration/google.webp";
import KeyValueBox from "./keyValueBox/keyValueBox";
import CodeBox from "./codeBoxComponent/codeBox";

const SearchConsole = () => {
  
  const codeSnippet = `const greet = () => {
    console.log("Hello, World!");
  };`;

  return (
    <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" }}>
      <div className="component-card">
        <div className="header_integration">
          <div className="name_header_int">
            
            <div className="int_heading_content">
            <h4>Search Console</h4>
              <span className="active_state active">Active</span>
              
            </div>
            
          </div>
          <img className="int_logo" src={google} />
          
        </div>

        <KeyValueBox label={"Verification Code"} value={"YOUR_VERIFICATION_CODE_HERE"} />
      </div>
    </div>
  );
};

export default SearchConsole;